(ns machtfit.stepchall.team-list
  (:require [goog.string :as gstring]
            [machtfit.app.routes :as routes]
            [machtfit.stepchall.help :as help]
            [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.search :as search]
            [machtfit.translation :refer [tr trn t]]
            [re-frame.core :as rf]))

(defn- headline []
  [:div.sc_vertical-center.sc_justify-center
   [:h3 {:style {:text-align "center"
                 :padding "0 15px"}}
    (tr "Möchtest du mitmachen?") [:br]
    (tr "Wähle jetzt dein Team.")]
   [help/help {:context :choose-team}]])

(defn- member-count-label [member-count max-team-size]
  [:div.sc_team-item-label
   (if (zero? member-count)
     (tr "noch keine Mitglieder")
     (if (some? max-team-size)
       (str member-count " / " max-team-size)
       (gstring/format (trn "%d Mitglied" "%d Mitglieder" member-count) member-count)))])

(defn- team-item [{:keys [id color name member-count requires-access-code?]}]
  (let [max-team-size @(rf/subscribe [:get [:stepchall :max-team-size]])]
    [:a.sc_team-item (routes/attrs-link-to-page {:id :stepchall
                                                 :subpage :join-team
                                                 :team-id id})
     [:div.sc_team-item-color {:style {:background-color color}}]
     [:div.sc_team-item-name (t name)]
     [member-count-label member-count max-team-size]
     (when requires-access-code? [:i.sc_icon.sc_team-item-locker [icons/locker]])]))

(rf/reg-sub ::long?
  :<- [:get [:stepchall :teams]]

  (fn [teams _]
    (<= 10 (count teams))))

(defn team-list []
  [:div.sc_content
   [headline]
   [:div.sc_team-list
    (if @(rf/subscribe [::long?])
      [search/searchbar {:id :team-list
                         :placeholder (t {:de "Team suchen…" :en "Search teams…"})}]
      [:div.spacer {:style {:margin-top "20px"}}])
    [:a.sc_team-item.sc_team-item-top (merge {:style {:margin-top "20px"}}
                                             (routes/attrs-link-to-page {:id :stepchall
                                                                         :subpage :create-team}))
     [:div.sc_team-item-plus [:i [icons/plus-circle]]]
     (tr "Neues Team gründen")]
    [:div
     (for [team (sort-by #(t (:name %)) @(rf/subscribe [::search/matching-teams :team-list]))]
       ^{:key (:id team)} [team-item team])]]])
